module.exports = __webpack_public_path__ + "img/U1F3C0.05a0ecb1.png";